var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChangeLayout = function SvgChangeLayout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#42A5F5",
    d: "M17.636 2.08H30.363999999999997V45.921H17.636z",
    transform: "rotate(-45.001 24 24)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M16.72 10.038H18.72V16.403H16.72z",
    transform: "rotate(-134.999 17.72 13.22)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M31.78 24.513H33.781V28.049000000000003H31.78z",
    transform: "rotate(45.001 32.781 26.281)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M14.75 7.482H16.75V11.018H14.75z",
    transform: "rotate(45.001 15.75 9.25)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M37.81 30.542H39.81V34.078H37.81z",
    transform: "rotate(45.001 38.81 32.31)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M20.75 13.482H22.75V17.018H20.75z",
    transform: "rotate(45.001 21.75 15.25)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M31.598 29.281H37.963V31.281H31.598z",
    transform: "rotate(-44.992 34.782 30.282)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E57373",
    d: "M42.583,9.067l-3.651-3.65c-0.555-0.556-1.459-0.556-2.015,0l-1.718,1.72l5.665,5.664l1.719-1.718C43.139,10.526,43.139,9.625,42.583,9.067"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9800",
    d: "M4.466 21.525H40.473V29.537H4.466z",
    transform: "rotate(-45.001 22.468 25.53)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0BEC5",
    d: "M34.612 7.379H38.618V15.391H34.612z",
    transform: "scale(-1) rotate(-45.02 -27.47 88.347)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M6.905 35.429L5 43 12.571 41.094z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M5.965 39.172L5 43 8.827 42.035z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChangeLayout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/change_layout.02f7fab5.svg";
export { ForwardRef as ReactComponent };